import i18n, { TFunction } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import config from "./config";

export enum Language {
    English = "en",
    French = "fr",
    Dutch = "nl",
    German = "de",
}

if (config.NODE_ENV === "test") {
    // only used in Jest
    i18n.use(initReactI18next).init(
        {
            fallbackLng: config.FALLBACK_LANGUAGE,
            debug: false,
            initImmediate: true,
            lng: config.FALLBACK_LANGUAGE,
            saveMissing: false,
            interpolation: {
                escapeValue: false, // React already does escaping
                skipOnVariables: false,
            },
            resources: {
                en: {
                    translation: {
                        // no keys
                    },
                },
            },
            react: {
                nsMode: "default",
                useSuspense: false,
            },
            returnNull: false,
            returnEmptyString: false,
            compatibilityJSON: "v3",
        },
        (_err, _t) => {
            /* resources are loaded */
        },
    );
} else {
    // application i18n
    const resources = {
        loadPath: `./locales/{{lng}}/{{ns}}.json?v=${config.BUILD.COMMIT_HASH?.substring(0, 7)}`,
    };

    i18n.use(Backend) // load translation using xhr -> see /public/locales. We will add locales in the next step
        .use(LanguageDetector) // detect user language
        .use(initReactI18next) // pass the i18n instance to react-i18next.
        .init(
            {
                fallbackLng: config.FALLBACK_LANGUAGE, // if user computer language is not on the list of available languages, then we will be using the fallback language specified earlier
                detection: {
                    lookupQuerystring: "lang",
                    lookupLocalStorage: "language",
                    excludeCacheFor: config.AVAILABLE_LANGUAGES, // we exclude here so we can store the cookie ourselves
                },
                debug: false,
                supportedLngs: config.AVAILABLE_LANGUAGES,
                interpolation: {
                    escapeValue: false,
                    skipOnVariables: false,
                },
                compatibilityJSON: "v3",
                backend: resources,
                returnNull: false,
                returnEmptyString: false,
            },
            (_err, _t) => {
                /* resources are loaded */
            },
        );
}

export const fakeI18n: { t: TFunction } = { t: ((key: string, _arg1?: any): string => key) as TFunction };

export default i18n;
